import { render, staticRenderFns } from "./customArticle.edit.vue?vue&type=template&id=634e6834&scoped=true"
import script from "./customArticle.edit.vue?vue&type=script&lang=js"
export * from "./customArticle.edit.vue?vue&type=script&lang=js"
import style0 from "./customArticle.edit.vue?vue&type=style&index=0&id=634e6834&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634e6834",
  null
  
)

export default component.exports